"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const TargetUtils_1 = require("./TargetUtils");
const INITIAL_CONTEXT = {
    get apiUrl() {
        return (0, TargetUtils_1.getApiUrl)(window.location);
    },
    get domain() {
        return (0, TargetUtils_1.getTargetMeta)(window.location).domain;
    },
    get metaInfo() {
        return (0, TargetUtils_1.getTargetMeta)(window.location).metaInfo;
    },
    get spaUrl() {
        return (0, TargetUtils_1.getSpaUrl)(window.location);
    },
    get staticUrl() {
        return (0, TargetUtils_1.getStaticUrl)(window.location);
    },
    get thirdParty() {
        return (0, TargetUtils_1.getTargetMeta)(window.location).thirdParty;
    },
    get strutsUrl() {
        return (0, TargetUtils_1.getStrutsUrl)(window.location);
    },
    get toApiUrl() {
        return TargetUtils_1.toApiUrl;
    },
    get toStrutsUrl() {
        return TargetUtils_1.toStrutsUrl;
    },
    get toStaticUrl() {
        return TargetUtils_1.toStaticUrl;
    },
    get toSpaUrl() {
        return TargetUtils_1.toSpaUrl;
    },
};
/**
 * React context that holds target information
 *
 * @deprecated TargetContext is not needed anymore. Get the values directly instead by
 *
 * ```typescript
 *   import { getApiUrl, getTargetMeta } from "@mne-core/providers/Target";
 *   const apiUrl = getApiUrl();
 *   const { apiUrl, baseUrl, metaInfo, domain, env, ...} = getTargetMeta();
 *
 * ```
 *
 */
exports.default = React.createContext(INITIAL_CONTEXT);
